export default "__VITE_ASSET__dfs6ytOD__"